<mat-card class="card nsp-wrapper">

    <button class="buttonClose" color="white" matTooltip="{{ 'SIDEBAR_WIDGET.CLOSE' | translate }}"
        [mat-dialog-close]="true"><span class="material-icons">close</span>
    </button>
    <mat-progress-spinner class="buttonSave" [diameter]="36" *ngIf="btnDisabled" color="primary" mode="indeterminate">
    </mat-progress-spinner>
    <button class="buttonSave" mat-flat-button color="primary" [disabled]="btnDisabled" (click)="saveAssessment()"
        matTooltip="{{ 'GLOBAL.SAVE' | translate }}">{{
        'GLOBAL.SAVE' | translate }}
    </button>
    <h2>{{ 'SUPERVISION.COMPETENCY_QUESTIONNAIRE.TITLE' | translate }}</h2>
    <mat-vertical-stepper #stepper>
        <mat-step>
            <ng-template matStepLabel>{{'SUPERVISION.COMPETENCY_QUESTIONNAIRE.FORM.FIRST_STEP_TITLE' |
                translate}}</ng-template>
            <form [formGroup]="firstStepForm" class="competency-form">
                <table class="competency-table mat-elevation-z1">
                    <tbody>
                        <app-row-form [ratingForm]="firstStepForm.get('legalRegulationsKnowledge')"
                            [labelMap]="firstStepLabelMap.legalRegulationsKnowledge" [ratings]="ratings"
                            step="FIRST_STEP">
                        </app-row-form>
                        <app-row-form [ratingForm]="firstStepForm.get('targetGroupKnowledge')"
                            [labelMap]="firstStepLabelMap.targetGroupKnowledge" [ratings]="ratings" step="FIRST_STEP">
                        </app-row-form>
                        <app-row-form [ratingForm]="firstStepForm.get('professionalKnowledgeApplication')"
                            [labelMap]="firstStepLabelMap.professionalKnowledgeApplication" [ratings]="ratings"
                            step="FIRST_STEP">
                        </app-row-form>
                        <app-row-form [ratingForm]="firstStepForm.get('caseManagementProcessKnowledge')"
                            [labelMap]="firstStepLabelMap.caseManagementProcessKnowledge" [ratings]="ratings"
                            step="FIRST_STEP">
                        </app-row-form>
                        <app-row-form [ratingForm]="firstStepForm.get('professionalProceduresKnowledge')"
                            [labelMap]="firstStepLabelMap.professionalProceduresKnowledge" [ratings]="ratings"
                            step="FIRST_STEP">
                        </app-row-form>
                        <app-row-form [ratingForm]="firstStepForm.get('caseDocumentation')"
                            [labelMap]="firstStepLabelMap.caseDocumentation" [ratings]="ratings" step="FIRST_STEP">
                        </app-row-form>
                        <app-row-form [ratingForm]="firstStepForm.get('independentCaseHandling')"
                            [labelMap]="firstStepLabelMap.independentCaseHandling" [ratings]="ratings"
                            step="FIRST_STEP">
                        </app-row-form>
                        <app-row-form [ratingForm]="firstStepForm.get('teamFormationAssessment')"
                            [labelMap]="firstStepLabelMap.teamFormationAssessment" [ratings]="ratings"
                            step="FIRST_STEP">
                        </app-row-form>
                    </tbody>
                </table>
                <form-footer>
                    <button matStepperNext mat-stroked-button color="primary" class="form-footer__button">
                        {{ 'GLOBAL.NEXT_STEP' | translate }}
                    </button>
                </form-footer>
            </form>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>{{'SUPERVISION.COMPETENCY_QUESTIONNAIRE.FORM.SECOND_STEP_TITLE' |
                translate}}</ng-template>
            <form [formGroup]="secondStepForm" class="competency-form">
                <table class="competency-table mat-elevation-z1">
                    <tbody>
                        <app-row-form [ratingForm]="secondStepForm.get('activeListening')"
                            [labelMap]="secondStepLabelMap.activeListening" [ratings]="ratings" step="SECOND_STEP">
                        </app-row-form>
                        <app-row-form [ratingForm]="secondStepForm.get('counselingAndSupportSkills')"
                            [labelMap]="secondStepLabelMap.counselingAndSupportSkills" [ratings]="ratings"
                            step="SECOND_STEP">
                        </app-row-form>
                        <app-row-form [ratingForm]="secondStepForm.get('interviewingSkills')"
                            [labelMap]="secondStepLabelMap.interviewingSkills" [ratings]="ratings" step="SECOND_STEP">
                        </app-row-form>
                        <app-row-form [ratingForm]="secondStepForm.get('assertivenessAndBoundarySettingSkills')"
                            [labelMap]="secondStepLabelMap.assertivenessAndBoundarySettingSkills" [ratings]="ratings"
                            step="SECOND_STEP">
                        </app-row-form>
                        <app-row-form [ratingForm]="secondStepForm.get('writtenCorrespondenceSkills')"
                            [labelMap]="secondStepLabelMap.writtenCorrespondenceSkills" [ratings]="ratings"
                            step="SECOND_STEP">
                        </app-row-form>
                        <app-row-form [ratingForm]="secondStepForm.get('negotiationSkills')"
                            [labelMap]="secondStepLabelMap.negotiationSkills" [ratings]="ratings" step="SECOND_STEP">
                        </app-row-form>
                        <app-row-form [ratingForm]="secondStepForm.get('teamwork')"
                            [labelMap]="secondStepLabelMap.teamwork" [ratings]="ratings" step="SECOND_STEP">
                        </app-row-form>
                        <app-row-form [ratingForm]="secondStepForm.get('expressionCulture')"
                            [labelMap]="secondStepLabelMap.expressionCulture" [ratings]="ratings" step="SECOND_STEP">
                        </app-row-form>
                        <app-row-form [ratingForm]="secondStepForm.get('conflictAndDifficultSituationManagement')"
                            [labelMap]="secondStepLabelMap.conflictAndDifficultSituationManagement" [ratings]="ratings"
                            step="SECOND_STEP">
                        </app-row-form>
                    </tbody>
                </table>
                <form-footer>
                    <button matStepperPrevious mat-stroked-button color="primary"
                        class="form-footer__button form-footer__button--secondary">
                        {{ 'GLOBAL.PREVIOUS_STEP' | translate }}
                    </button>
                    <button matStepperNext mat-stroked-button color="primary" class="form-footer__button">
                        {{ 'GLOBAL.NEXT_STEP' | translate }}
                    </button>
                </form-footer>
            </form>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>{{'SUPERVISION.COMPETENCY_QUESTIONNAIRE.FORM.THIRD_STEP_TITLE' |
                translate}}</ng-template>
            <form [formGroup]="thirdStepForm" class="competency-form">
                <table class="competency-table mat-elevation-z1">
                    <tbody>
                        <app-row-form [ratingForm]="thirdStepForm.get('workingHoursAndDisciplineRespect')"
                            [labelMap]="thirdStepLabelMap.workingHoursAndDisciplineRespect" [ratings]="ratings"
                            step="THIRD_STEP">
                        </app-row-form>
                        <app-row-form [ratingForm]="thirdStepForm.get('timeManagement')"
                            [labelMap]="thirdStepLabelMap.timeManagement" [ratings]="ratings" step="THIRD_STEP">
                        </app-row-form>
                        <app-row-form [ratingForm]="thirdStepForm.get('timelyAndEffectiveInterventionPlanning')"
                            [labelMap]="thirdStepLabelMap.timelyAndEffectiveInterventionPlanning" [ratings]="ratings"
                            step="THIRD_STEP">
                        </app-row-form>
                        <app-row-form [ratingForm]="thirdStepForm.get('initiative')"
                            [labelMap]="thirdStepLabelMap.initiative" [ratings]="ratings" step="THIRD_STEP">
                        </app-row-form>
                        <app-row-form [ratingForm]="thirdStepForm.get('flexibility')"
                            [labelMap]="thirdStepLabelMap.flexibility" [ratings]="ratings" step="THIRD_STEP">
                        </app-row-form>
                        <app-row-form [ratingForm]="thirdStepForm.get('decisiveness')"
                            [labelMap]="thirdStepLabelMap.decisiveness" [ratings]="ratings" step="THIRD_STEP">
                        </app-row-form>
                    </tbody>
                </table>
                <form-footer>
                    <button matStepperPrevious mat-stroked-button color="primary"
                        class="form-footer__button form-footer__button--secondary">
                        {{ 'GLOBAL.PREVIOUS_STEP' | translate }}
                    </button>
                    <button matStepperNext mat-stroked-button color="primary" class="form-footer__button">
                        {{ 'GLOBAL.NEXT_STEP' | translate }}
                    </button>
                </form-footer>
            </form>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>{{'SUPERVISION.COMPETENCY_QUESTIONNAIRE.FORM.FOURTH_STEP_TITLE' |
                translate}}</ng-template>
            <form [formGroup]="fourthStepForm" class="competency-form">
                <table class="competency-table mat-elevation-z1">
                    <tbody>
                        <app-row-form [ratingForm]="fourthStepForm.get('respectForDiversity')"
                            [labelMap]="fourthStepLabelMap.respectForDiversity" [ratings]="ratings" step="FOURTH_STEP">
                        </app-row-form>
                        <app-row-form [ratingForm]="fourthStepForm.get('userEmpowerment')"
                            [labelMap]="fourthStepLabelMap.userEmpowerment" [ratings]="ratings" step="FOURTH_STEP">
                        </app-row-form>
                        <app-row-form [ratingForm]="fourthStepForm.get('rightsAdvocacy')"
                            [labelMap]="fourthStepLabelMap.rightsAdvocacy" [ratings]="ratings" step="FOURTH_STEP">
                        </app-row-form>
                        <app-row-form [ratingForm]="fourthStepForm.get('maintainingProfessionalBoundaries')"
                            [labelMap]="fourthStepLabelMap.maintainingProfessionalBoundaries" [ratings]="ratings"
                            step="FOURTH_STEP">
                        </app-row-form>
                    </tbody>
                </table>
                <form-footer>
                    <button matStepperPrevious mat-stroked-button color="primary"
                        class="form-footer__button form-footer__button--secondary">
                        {{ 'GLOBAL.PREVIOUS_STEP' | translate }}
                    </button>
                    <button matStepperNext mat-stroked-button color="primary" class="form-footer__button">
                        {{ 'GLOBAL.NEXT_STEP' | translate }}
                    </button>
                </form-footer>
            </form>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>{{'SUPERVISION.COMPETENCY_QUESTIONNAIRE.FORM.FIFTH_STEP_TITLE' |
                translate}}</ng-template>
            <form [formGroup]="fifthStepForm" class="competency-form">
                <table class="competency-table mat-elevation-z1">
                    <tbody>
                        <app-row-form [ratingForm]="fifthStepForm.get('opennessToSupervision')"
                            [labelMap]="fifthStepLabelMap.opennessToSupervision" [ratings]="ratings" step="FIFTH_STEP">
                        </app-row-form>
                        <app-row-form [ratingForm]="fifthStepForm.get('criticalSelfAssessment')"
                            [labelMap]="fifthStepLabelMap.criticalSelfAssessment" [ratings]="ratings" step="FIFTH_STEP">
                        </app-row-form>
                        <app-row-form [ratingForm]="fifthStepForm.get('learningAndProfessionalDevelopment')"
                            [labelMap]="fifthStepLabelMap.learningAndProfessionalDevelopment" [ratings]="ratings"
                            step="FIFTH_STEP">
                        </app-row-form>
                    </tbody>
                </table>
                <form-footer>
                    <button matStepperPrevious mat-stroked-button color="primary"
                        class="form-footer__button form-footer__button--secondary">
                        {{ 'GLOBAL.PREVIOUS_STEP' | translate }}
                    </button>
                    <button matStepperNext mat-stroked-button color="primary" class="form-footer__button">
                        {{ 'GLOBAL.NEXT_STEP' | translate }}
                    </button>
                </form-footer>
            </form>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>{{'SUPERVISION.COMPETENCY_QUESTIONNAIRE.FORM.SIXTH_STEP_TITLE' |
                translate}}</ng-template>
            <form [formGroup]="sixthStepForm" class="competency-form">
                <field-holder>
                    <mat-form-field appearance="outline">
                        <mat-label>{{
                            'SUPERVISION.COMPETENCY_QUESTIONNAIRE.FORM.SIXTH_STEP_FORM.CASE_MANAGER_STRENGTHS'
                            | translate }}</mat-label>
                        <textarea matInput rows="3" formControlName="caseManagerStrengths"></textarea>
                    </mat-form-field>
                </field-holder> <field-holder>
                    <mat-form-field appearance="outline">
                        <mat-label>{{
                            'SUPERVISION.COMPETENCY_QUESTIONNAIRE.FORM.SIXTH_STEP_FORM.AREAS_FOR_IMPROVEMENT'
                            | translate }}</mat-label>
                        <textarea matInput rows="3" formControlName="areasForImprovement"></textarea>
                    </mat-form-field>
                </field-holder>
                <form-footer>
                    <button matStepperPrevious mat-stroked-button color="primary"
                        class="form-footer__button form-footer__button--secondary">
                        {{ 'GLOBAL.PREVIOUS_STEP' | translate }}
                    </button>
                    <button matStepperNext mat-stroked-button color="primary" class="form-footer__button">
                        {{ 'GLOBAL.NEXT_STEP' | translate }}
                    </button>
                </form-footer>
            </form>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>{{'SUPERVISION.COMPETENCY_QUESTIONNAIRE.FORM.SEVENTH_STEP_TITLE' |
                translate}}</ng-template>
            <div class="table-responsive-wrapper">
                <table mat-table id="myTable" class="subjects__table" [dataSource]="goals" #myTable>
                    <ng-container matColumnDef="goal">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ 'SUPERVISION.COMPETENCY_QUESTIONNAIRE.FORM.SEVENTH_STEP_FORM.GOAL' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element?.goal }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="activities">
                        <th mat-header-cell *matHeaderCellDef>{{
                            'SUPERVISION.COMPETENCY_QUESTIONNAIRE.FORM.SEVENTH_STEP_FORM.ACTIVITIES' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            {{ element?.activities }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="timeframe">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ 'SUPERVISION.COMPETENCY_QUESTIONNAIRE.FORM.SEVENTH_STEP_FORM.TIMEFRAME' | translate
                            }}
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            {{ element?.timeframe | date:"dd.MM.yyyy." }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="responsiblePerson">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ 'SUPERVISION.COMPETENCY_QUESTIONNAIRE.FORM.SEVENTH_STEP_FORM.RESPONSIBLE_PERSON' |
                            translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element?.responsiblePerson }}</td>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element;let i = index"
                            class="table__cell table__cell--align-right">
                            <button mat-icon-button class="button-square table__row-button" color="primary"
                                [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger"
                                (click)="$event.stopPropagation()">
                                <mat-icon class="button-square__icon">more_horiz</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu" class="filter-menu">
                                <button mat-menu-item (click)="editGoal(element,i)">
                                    <mat-icon>edit</mat-icon>
                                    {{ 'GLOBAL.EDIT' | translate }}
                                </button>
                                <button mat-menu-item (click)="deleteGoal(i)">
                                    <mat-icon>delete</mat-icon>
                                    {{ 'GLOBAL.DELETE' | translate }}
                                </button>
                            </mat-menu>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="subjects__row--header"></tr>
                    <tr mat-row *matRowDef="let element;  let i = index; columns: displayedColumns"
                        class="subjects__row">
                    </tr>
                </table>
                <button mat-flat-button mat-stroked-button color="primary" (click)="addGoal()"
                    class="form-footer__button form-footer__button--secondary">
                    <mat-icon>person_add</mat-icon>
                    {{ 'SUPERVISION.COMPETENCY_QUESTIONNAIRE.FORM.SEVENTH_STEP_FORM.ADD_STEP_OR_PLAN' | translate }}
                </button>
            </div>
            <form-footer>
                <button matStepperPrevious mat-stroked-button color="primary"
                    class="form-footer__button form-footer__button--secondary">
                    {{ 'GLOBAL.PREVIOUS_STEP' | translate }}
                </button>
                <button mat-flat-button color="primary" [disabled]="btnDisabled"
                    class="form-footer__button form-footer__button--secondary" (click)="generateReport()">
                    {{ 'GLOBAL.GENERATE' | translate }}
                </button>
                 <mat-progress-spinner [diameter]="36" *ngIf="btnDisabled" color="primary" mode="indeterminate">
                </mat-progress-spinner>
            </form-footer>
        </mat-step>
    </mat-vertical-stepper>
</mat-card>